var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"wrapper"},[_c('div',{staticClass:"header container",class:{ 'header_search-expanded': _vm.isSearchExpanded }},[_c('v-logo',{staticClass:"header__logo",attrs:{"to":_vm.homeLink}}),_c('theme-switch',{staticClass:"header__theme-switch"}),_c('device',{staticClass:"header__device"})],1),_c('navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }